<template>

    <div class="joker">

        <greenfox v-if="card.type === ENUM.NEWSLETTERS.CARDS.GREENFOX"
                  :card="card"></greenfox>

        <market v-if="card.type === ENUM.NEWSLETTERS.CARDS.MARKET"
                :card="card"></market>

        <sharing v-if="card.type === ENUM.NEWSLETTERS.CARDS.SHARING"
                 @share="$emit('share')"></sharing>

        <subscriptions v-if="showCardSubscriptions" :subscription="card"></subscriptions>

    </div>

</template>

<script>

import ENUM from '@/assets/ENUM'

import Greenfox from '@/components/newsletters-v2/cardsTemplate/Greenfox'
import Market from '@/components/newsletters-v2/cardsTemplate/Market'
import Sharing from '@/components/newsletters-v2/cardsTemplate/Sharing'
import Subscriptions from '@/components/newsletters-v2/cardsTemplate/Subscriptions'

export default {

    name: 'joker',

    components: {
        Greenfox,
        Market,
        Sharing,
        Subscriptions
    },

    props: {
        card: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },

    computed: {
        ENUM() {
            return ENUM
        },

        showCardSubscriptions() {
            return this.card.type !== ENUM.NEWSLETTERS.CARDS.GREENFOX
                && this.card.type !== ENUM.NEWSLETTERS.CARDS.MARKET
                && this.card.type !== ENUM.NEWSLETTERS.CARDS.SHARING
        }
    }
}

</script>

<style lang="scss" scoped>

.joker {
    width: 100%;
    display: flex;
    flex-grow: 1;
    border-radius: 72px;
}

</style>
